import { VoteOption } from "@/types/vote";

import { imageUnselectedClassNames } from "./VoteResults";

interface VoteOptionsProps {
    options: VoteOption[];
    onVote: (optionId: number) => void;
    disabled?: boolean;
    firstImage?: string | null;
    secondImage?: string | null;
}

/**
 * 투표 옵션 버튼 컴포넌트
 * 투표 전 선택 가능한 옵션들을 표시
 */
export const VoteOptions: React.FC<VoteOptionsProps> = ({
    options,
    onVote,
    disabled = false,
    firstImage,
    secondImage
}) => {
    // 이미지가 있는 경우와 없는 경우를 분기 처리
    const hasImages = firstImage || secondImage;

    if (hasImages) {
        return (
            <div className="flex flex-col gap-4">
                {/* 이미지 그리드 */}
                <div className="grid grid-cols-2 gap-4">
                    {/* 첫 번째 옵션 이미지 */}
                    {options[0] && (
                        <button
                            onClick={() => onVote(options[0]!.id)}
                            disabled={disabled}
                            className="group relative overflow-hidden rounded-lg transition-all duration-200 hover:-translate-y-1 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {firstImage ? (
                                <img
                                    src={firstImage}
                                    alt={options[0].text}
                                    className={imageUnselectedClassNames}
                                />
                            ) : (
                                <div className="flex aspect-square items-center justify-center bg-gray-100 dark:bg-gray-900">
                                    <span className="text-sm text-gray-400">
                                        이미지 없음
                                    </span>
                                </div>
                            )}
                            {/* 호버 오버레이 */}
                            <div className="absolute inset-0 bg-black/0 transition-all duration-200 group-hover:bg-black/10" />
                        </button>
                    )}

                    {/* 두 번째 옵션 이미지 */}
                    {options[1] && (
                        <button
                            onClick={() => onVote(options[1]!.id)}
                            disabled={disabled}
                            className="group relative overflow-hidden rounded-lg transition-all duration-200 hover:-translate-y-1 hover:shadow-lg disabled:cursor-not-allowed disabled:opacity-50"
                        >
                            {secondImage ? (
                                <img
                                    src={secondImage}
                                    alt={options[1].text}
                                    className={imageUnselectedClassNames}
                                />
                            ) : (
                                <div className="flex aspect-square items-center justify-center bg-gray-100 dark:bg-gray-900">
                                    <span className="text-sm text-gray-400">
                                        이미지 없음
                                    </span>
                                </div>
                            )}
                            {/* 호버 오버레이 */}
                            <div className="absolute inset-0 bg-black/0 transition-all duration-200 group-hover:bg-black/10" />
                        </button>
                    )}
                </div>

                {/* 텍스트 옵션 버튼 */}
                <div className="flex-start flex flex-col gap-2.5">
                    {options.map((option) => (
                        <button
                            key={option.id}
                            onClick={() => onVote(option.id)}
                            disabled={disabled}
                            className="rounded-xl border-2 border-gray-900 bg-gray-100 px-4 py-3.5 text-[15px] font-semibold text-gray-900 transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-500 hover:bg-gray-50 hover:shadow-md hover:shadow-gray-500/20 active:translate-y-0 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-900 dark:text-white dark:hover:bg-gray-500"
                        >
                            {option.text}
                        </button>
                    ))}
                </div>
            </div>
        );
    }

    // 이미지가 없는 경우 기존 UI 유지
    return (
        <div className="flex flex-col gap-2.5">
            {options.map((option) => (
                <button
                    key={option.id}
                    onClick={() => onVote(option.id)}
                    disabled={disabled}
                    className="rounded-xl border-2 border-gray-200 bg-gray-100 px-4 py-3.5 text-left text-[15px] font-semibold text-gray-900 transition-all duration-200 hover:-translate-y-0.5 hover:border-gray-500 hover:bg-gray-50 hover:shadow-md hover:shadow-gray-500/20 active:translate-y-0 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-900 dark:text-white dark:hover:bg-gray-500"
                >
                    {option.text}
                </button>
            ))}
        </div>
    );
};
